var description_default = {
  "subtitle": "-ySFQ",
  "descriptionItem": "_0ald-"
};
export {
  description_default as default
};
//# sourceMappingURL=description-scss.js.map
